import { cx } from "../../lib/cx.js";
export function createAutocompleteDetachedOverlayComponent(_ref) {
  var createElement = _ref.createElement;
  return function AutocompleteDetachedOverlay(userProps) {
    var children = userProps.children,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      onClose = userProps.onClose;
    return createElement("div", {
      className: cx('ais-AutocompleteDetachedOverlay', classNames.detachedOverlay),
      onMouseDown: onClose
    }, children);
  };
}